function updateSelectionStyles(host, targetTab) {
  if (!targetTab)
    targetTab = host.tabs.find(
      (tab) => tab.getAttribute("aria-selected") === "true"
    );
  if (!targetTab)
    return;
  const offset = host.hasAttribute("skapa-rtl") ? host.offsetWidth - targetTab.offsetLeft : targetTab.offsetLeft;
  host.selectionHighlight.style.setProperty(
    "--tab-selection-offset",
    `${offset}px`
  );
  host.selectionHighlight.style.setProperty(
    "--tab-selection-width",
    `${targetTab.offsetWidth}px`
  );
}
function instantUpdateSelectionStyles(host, targetTab) {
  host.selectionHighlight.classList.toggle("instant", true);
  host.micro(() => {
    updateSelectionStyles(host, targetTab);
    host.selectionHighlight.classList.toggle("instant", false);
  }, "realign the selection underline on wd change");
}
export {
  instantUpdateSelectionStyles,
  updateSelectionStyles
};
